import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton';

const AddUserMails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = location.state?.userData;
  const isEditMode = Boolean(userData);
  const [userTypes, setUserTypes] = useState([]);

  const initialFormData = {
    UserType: '',
    BUMailId: '',
    Port: '',
    Host: '',
    NetUserName: '',
    NetPassword: '',
    IsActive: false,
    MailType: '', 
    // S3BucketName: '', 
    // S3UploadUrl: '', 
    // S3DownloadUrl: '', 
    // S3FolderPath: '', 
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEditMode && userData) {
      console.log('Edit Mode Data:', userData);
      setFormData({
        UserType: userData?.bUId || '',
        BUMailId: userData?.buMailId || '',
        Port: userData?.port || '',
        Host: userData?.host || '',
        NetUserName: userData?.netUserName || '',
        NetPassword: userData?.netPassword || '',
        IsActive: userData?.isActive || false,
        // BUId: userData?.BUId || '',
        MailType: userData?.mailType || '', 
        // S3BucketName: userData?.s3BucketName || '', 
        // S3UploadUrl: userData?.s3UploadUrl || '',  
        // S3DownloadUrl: userData?.s3DownloadUrl || '', 
        // S3FolderPath: userData?.s3FolderPath || '', 

      });
    }
  }, [isEditMode, userData]);

  useEffect(() => {
    const fetchUserTypes = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/Login/GetUserList`);
        if (!response.ok) throw new Error('Failed to fetch Users');
        const data = await response.json();
        setUserTypes(data); // Assume that the response is an array of Users
      } catch (error) {
        console.error('Error fetching Users:', error);
      }
    };

    fetchUserTypes();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => ({ ...prev, [name]: newValue }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = {
     // UserType: 'User',
      MailType: 'Mail Type',
      BUMailId: 'Email',
      Port: 'Port',
      Host: 'Host',
      NetUserName: 'Username',
      NetPassword: 'Password',
      // S3BucketName:'S3BucketName',
      // S3UploadUrl:'S3UploadUrl',
      // S3DownloadUrl:'S3DownloadUrl',
      // S3FolderPath:'S3FolderPath'
    };

    Object.entries(requiredFields).forEach(([field, label]) => {
      if (!formData[field]?.trim()) {
        newErrors[field] = `${label} is required`;
      }
    });

    if (formData.BUMailId && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.BUMailId)) {
      newErrors.BUMailId = 'Please enter a valid email address';
    }

    if (formData.Port && !/^\d+$/.test(formData.Port)) {
      newErrors.Port = 'Port must be a number';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submit triggered');
  
    const newErrors = validateForm();
    console.log('Validation Errors:', newErrors); // Log errors
  
    if (Object.keys(newErrors).length === 0) {
      console.log('Form is valid, submitting...');
      setLoading(true);
  
      console.log('Submitting form data:', formData);
  
      try {
        const url = isEditMode
          ? `${process.env.REACT_APP_API_URL}/Login/UpdateBusinessUnitDetails/`
          : `${process.env.REACT_APP_API_URL}/Login/SaveBusinessUnitDetails`;
  
        const formDataToSubmit = {
          ...formData,
          BUId: formData.UserType,  // Add buId to the form data
        };
  
        const response = await fetch(url, {
          method: isEditMode ? 'PUT' : 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formDataToSubmit),
        });
  
        console.log('API Response:', response); // Log the response
  
        const data = await response.json();
        console.log('API Data:', data); // Log the data
  
        if (data) {
          alert(`${data.response}`);
          navigate(-1); 
        } else {
          throw new Error(data.message || 'An error occurred');
        }
      } catch (error) {
        console.error('Error:', error);
        alert(error.message || 'An error occurred. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(newErrors);
    }
  };
console.log(userTypes)
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="flex justify-end mb-4">
        <BackButton label="Back" />
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">
            {isEditMode ? 'UPDATE' : 'CREATE'} BU MAIL DETAILS
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-lg shadow">
          {/* User Dropdown */}
          <div>
  <label htmlFor="UserType" className="block text-sm font-medium text-gray-700">
    User
  </label>

  {isEditMode ? (
    // Read-only view when in edit mode
    <input
      type="text"
      id="UserType"
      className="mt-1 block w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2"
      value={
        // Try multiple fallback options to find the user name
        userTypes.find((type) => 
          type.buId === formData.UserType || 
          type.buId === userData?.BUId || 
          type.buId === userData?.buId ||
          type.buName === userData?.buName ||
          type.buName === userData?.BUName
        )?.buName || 
        userData?.buName || 
        userData?.BUName || 
        formData.UserType || 
        'User not found'
      }
      readOnly
    />
  ) : (
    // Editable select when not in edit mode
    <select
      name="UserType"
      id="UserType"
      value={formData.UserType || ''}
      onChange={handleChange}
      className={`mt-1 block w-full rounded-md border ${errors.UserType ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500`}
    >
      <option value="">Select User</option>
      {userTypes.map((type) => (
        <option key={type.buName} value={type.buId}>
          {type.buName}
        </option>
      ))}
    </select>
  )}

  {errors.UserType && (
    <p className="mt-1 text-sm text-red-600">{errors.UserType}</p>
  )}
</div>


          {/* Mail Type Dropdown */}
          <div>
            <label htmlFor="MailType" className="block text-sm font-medium text-gray-700">
              Mail Type
            </label>
            <select
              name="MailType"
              id="MailType"
              value={formData.MailType || ''}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border ${errors.MailType ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500`}
            >
              <option value="">Select Mail Type</option>
              {['AWS', 'SMTP'].map((type) => (
                <option key={type} value={type}>
                  {type}
                </option>
              ))}
            </select>
            {errors.MailType && (
              <p className="mt-1 text-sm text-red-600">{errors.MailType}</p>
            )}
          </div>

          {/* Form Fields */}
          {[
            { name: 'BUMailId', label: 'Email Address', type: 'email' },
            { name: 'Port', label: 'Port', type: 'text' },
            { name: 'Host', label: 'Host', type: 'text' },
            { name: 'NetUserName', label: 'User Name', type: 'text' },
            { name: 'NetPassword', label: 'Password', type: 'text' },
            // { name: 'S3BucketName', label: 'Bucket Name', type: 'text' },
            // { name: 'S3UploadUrl', label: 'Upload Url', type: 'text' },
            // { name: 'S3DownloadUrl', label: 'Download Url', type: 'text' },
            // { name: 'S3FolderPath', label: 'Folder Path', type: 'text' },
          ].map((field) => (
            <div key={field.name}>
              <label htmlFor={field.name} className="block text-sm font-medium text-gray-700">
                {field.label}
              </label>
              <input
                type={field.type}
                name={field.name}
                id={field.name}
                value={formData[field.name] || ''}
                onChange={handleChange}
                readOnly={field.name === 'BUMailId' && isEditMode}
                className={`mt-1 block w-full rounded-md border ${errors[field.name] ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 ${field.name === 'BUMailId' && isEditMode ? 'bg-gray-100' : ''}`}
              />
              {errors[field.name] && (
                <p className="mt-1 text-sm text-red-600">{errors[field.name]}</p>
              )}
            </div>
          ))}

          <div className="flex items-center">
            <input
              type="checkbox"
              name="IsActive"
              id="IsActive"
              checked={formData.IsActive}
              onChange={handleChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="IsActive" className="ml-2 text-sm font-medium text-gray-700">
              Is Active
            </label>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Saving...' : isEditMode ? 'UPDATE' : 'SAVE'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserMails;
